import * as React from 'react';
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import Checkbox from '@mui/material/Checkbox';
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {setStore} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import {Translate} from "./../../../../config/Translate";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";


class StatusChooser extends React.Component{
    state = {
        loading:true,
        statuses: [],
        current: 1,
        transfer_type: "airplane"
    };

    async componentDidMount(){
        await this.setState({
            transfer_type:this.props.transfer_type,
            current:this.props.current,
            loading:true,
        })
        await this.loadData();
    }
    async componentDidUpdate(oldProps){
        if(
            this.state.transfer_type !== this.props.transfer_type
            ||
            this.state.current !== this.props.current
        ){
            await this.setState({
                transfer_type:this.props.transfer_type,
                current:this.props.current,
                loading:true,
            })
            await this.loadData()
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/statuses/get/${this.state.transfer_type}`, config)
                .then(response => {
                    this.setState({
                        statuses: response.data,
                        loading:false
                    })
                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChangeCurrent(id){
        this.setState({
            current: id
        })
        this.props.handleStatus(id);
    }
    render(){
        let {loading,statuses,current,transfer_type} = this.state;
        return (
            <>
                {
                    loading ? <AppCardLoaderFields/> :
                        <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                            {statuses.map((status,item) => {
                                return (
                                    <ListItem
                                        button
                                        key={item}
                                        onClick={() => this.handleChangeCurrent(status.id)}
                                        disablePadding
                                    >
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="end"
                                                    onChange={() => this.handleChangeCurrent(status.id)}
                                                    checked={status.id ===  current}
                                                    inputProps={{ 'aria-labelledby': status.id }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                id={status.id}
                                                primary={`${transfer_type === "airplane" ? status.airplane_name : status.ship_name} (${transfer_type === "airplane" ? status.airplane_duration : status.ship_duration} ${Translate.days})`}
                                            />

                                    </ListItem>
                                );
                            })}
                        </List>
                }

            </>
        );
    }
}

export default StatusChooser;